'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Tab", {
    enumerable: true,
    get: function() {
        return Tab;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTab = require("./useTab");
const _renderTab = require("./renderTab");
const _useTabStylesstyles = require("./useTabStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Tab = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTab.useTab_unstable)(props, ref);
    (0, _useTabStylesstyles.useTabStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTabStyles_unstable')(state);
    return (0, _renderTab.renderTab_unstable)(state);
});
Tab.displayName = 'Tab';
